import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { TextInput } from '@/components/Form/TextInput';

import { EMAIL_PATTERN } from '@/constants/patterns';

import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

type EmailInputProps = {
  disabled: boolean;
};

export const EmailInput = ({ disabled }: EmailInputProps) => {
  const { t } = useTranslate();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid item xs={12}>
      <TextInput
        type="email"
        inputMode="email"
        name="email"
        placeholder={t('login.form.email.placeHolder')}
        control={control}
        error={!!errors.email}
        helperText={errors.email?.message as string}
        rules={{
          required: t('login.form.email.error.required'),
          pattern: {
            value: new RegExp(EMAIL_PATTERN),
            message: t('login.form.email.error.incorrectFormat'),
          },
          maxLength: {
            value: 40,
            message: t('login.form.email.error.maxLength'),
          },
        }}
        disabled={disabled}
        {...getDataTestId(`email-input`)}
      />
    </Grid>
  );
};
